import { Button, Grid, Spinner } from '@chakra-ui/react'
import type { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { priceFormat, toDate } from 'BrokerTsLib/src/Utils/formatPrice'
import moment from 'moment'
import { useState } from 'react'

import { DatepickerPopup } from '@/components/DatepickerPopup'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { useOffersAddonContext } from '@/context/OffersAddonProvider'
import { useOffersVehicleContext } from '@/context/OffersVehicleProvider'
import { useStepsContext } from '@/context/StepsContext'
import { useWizzardHeader } from '@/context/WizzardHeaderContext'
import { useYearKm } from '@/hooks'
import { useUpdateInsuranceStartDate } from '@/hooks/useWizard'

import { InsuranceInfoFormControl } from './InsuranceInfoFormControl'

export const InsuranceSettingsForm = () => {
  const { isScrolled } = useWizzardHeader()
  const { currentStepId } = useStepsContext()
  const { insuranceParams: ip, insuranceParamsId, refetchInsuranceParams, isDisabled } = useInsuranceParams()
  const insuranceParams = ip as InsuranceParamsDto
  const { mutateAsync: updateInsuranceStartDate } = useUpdateInsuranceStartDate(insuranceParamsId!)
  const { recalculateOffers: recalculate, offers } = useOffersVehicleContext()
  const { recalculateOffers: recalculateAddonOffers, offers: addonOffers } = useOffersAddonContext()
  const { data: dataYearKm } = useYearKm(insuranceParams!.vehicle.druh!)

  const startDate = insuranceParams!.generalParams.insuranceStartDate

  const isDateInvalid = startDate
    ? new Date(startDate) < toDate(new Date())!
    : true


  const [isSavingInsruanceStartDate, setIsSavingInsruanceStartDate] = useState(false)
  const handleSetStartDate = (date: Date) => {
    setIsSavingInsruanceStartDate(true)

    updateInsuranceStartDate(date)
      .then(() => {
        recalculate(offers.map(o => o.offerId), true)

        if (addonOffers && addonOffers.length > 0)
          recalculateAddonOffers(addonOffers.map(ao => ao.offerId), true)

        refetchInsuranceParams() // aby se updatnul header
      })
      .finally(() => setIsSavingInsruanceStartDate(false))
  }

  const now = new Date()

  return (
    <>
      <Grid
        sx={{
          gap: isScrolled ? 0 : 1,
          gridAutoFlow: 'column',
          gridTemplateColumns: 'repeat(3, 1fr)',
        }}
      >
        <InsuranceInfoFormControl
          label="Počátek pojištění"
          value={moment(startDate).format('D. M. YYYY')}
          hasError={!isDisabled && isDateInvalid}
          errorMessage={!isDisabled && isDateInvalid ? 'Datum nesmí být v minulosti' : null}
          leftControl={
            <>
              {!isDisabled && currentStepId == 2 &&
                <Button variant="unstyled" size="sm">
                  {!isSavingInsruanceStartDate &&
                    <DatepickerPopup
                      date={now}
                      onDateChange={(date: Date) => handleSetStartDate(date)}
                      dateMin={new Date(now.toDateString())}
                      iconProps={{
                        color: isDateInvalid ? 'red.500' : 'insurance-info-value-color'
                      }}
                    />}
                  {isSavingInsruanceStartDate && <Spinner color={isDateInvalid ? 'red.500' : 'insurance-info-value-color'} />}
                </Button>
              }
            </>
          }
        />

        <InsuranceInfoFormControl
          label="Pojistná částka"
          value={`${priceFormat(insuranceParams!.vehicle.price)} ${insuranceParams!.vehicle.priceIncludeVat ? 's DPH' : 'bez DPH'}`}
        />

        <InsuranceInfoFormControl
          label="Roční nájezd km"
          value={dataYearKm?.data.find(x => x.value == insuranceParams?.vehicle?.yearKm)?.name}
          emptyLabel="nechci uvést"
        />
      </Grid>
    </>
  )
}
